import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import OptionCriteriaRadioButton from "./OptionCriteriaRadioButton";
import { SEARCH_FORM_ROW_GAP } from "./search-form-constants";
import UserFieldsForm from "./user-fields-form/index";

const SearchForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: SEARCH_FORM_ROW_GAP * unitY
      }}
      onClick={() => {}}
    >
      <OptionCriteriaRadioButton />
      <UserFieldsForm />
    </ET3Div>
  );
});
export default SearchForm;
